var e = { icon: { tag: "svg", attrs: { viewBox: "0 0 16 16", focusable: "false", fill: "currentColor" }, children: [{ tag: "path", attrs: { d: "M15.65 4.24L6.5 13.4c-.45.45-1.17.46-1.62.02l-.03-.02c-.02-.01-.02-.03-.04-.06l-.06-.03-4.4-4.4a1.19 1.19 0 010-1.66c.45-.46 1.19-.46 1.65 0l3.68 3.68 8.35-8.35a1.14 1.14 0 011.6-.03l.03.03c.46.45.47 1.17.02 1.63l-.02.02", "fill-rule": "evenodd" } }] }, name: "check", theme: "outlined" };
export {
  e as default
};
